import { useQuery } from '@tanstack/react-query';

import { RequestForQuoteViewFilterMessage } from '../../../../types/RequestForQuoteViewFilterMessage';
import { queries } from '../../../common/api/queryKeys/queries';

interface UseRequestForQuoteViewPaginationTotalsParams extends Omit<RequestForQuoteViewFilterMessage, 'states'> {
    tabToOfferStateMap: Record<string, string[]>;
}

export const useRfqPaginationTotals = ({
    tabToOfferStateMap,
    ...filterParams
}: UseRequestForQuoteViewPaginationTotalsParams) => {
    const offerTabs = ['enquired', 'ordered', 'acknowledged', 'confirmed', 'delivered', 'canceled', 'expired'];
    const fetchTotals = (baseFilter: Omit<RequestForQuoteViewFilterMessage, 'states'>) => {
        return Promise.all(
            offerTabs.map((tab) => {
                const filter: RequestForQuoteViewFilterMessage = {
                    ...baseFilter,
                    states: tabToOfferStateMap[tab],
                };
                const { queryFn } = queries.requestsForQuotes.count(filter);
                return queryFn({} as any);
            })
        ).then((counts) => {
            return offerTabs.reduce(
                (acc, tab, index) => {
                    acc[tab] = counts[index];
                    return acc;
                },
                {} as Record<string, number>
            );
        });
    };

    return useQuery({
        queryKey: queries.requestsForQuotes.totals(filterParams).queryKey,
        queryFn: () => fetchTotals(filterParams),
        refetchOnWindowFocus: false,
    });
};
